import { Component, inject } from '@angular/core';

import { AuthService } from '@services/api/auth/auth.service';
import { FlatButtonComponent } from '@shared/button/flat-button/flat-button.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.page.component.html',
    styleUrl: './login.page.component.scss',
    imports: [FlatButtonComponent],
})
export class LoginPageComponent {
    private readonly authService = inject(AuthService);

    login() {
        this.authService.login();
    }

    ssoLogin() {
        this.authService.ssoLogin();
    }

    loginWithWorkflowCredentials() {
        this.login();
    }

    loginWithSso() {
        this.ssoLogin();
    }
}
